import ReduxPageReducer from "./reducer";
import * as ReduxPageActions from "./actions";
import * as ReduxPageConstants from "./constants";

const pageActions = ReduxPageActions;
const pageReducer = ReduxPageReducer;
const pageConstants = ReduxPageConstants;

export { pageReducer, pageActions, pageConstants }